import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HallPass } from 'app/models';
import { receiveUpdate } from 'app/ngrx/live-updates/live-updates.actions';
import { HttpService } from 'app/services/http-service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { isTruthy, pickTruthy } from 'Util';
import { Invitation } from '../../../../models/Invitation';
import {
	addInvitation,
	getInvitations,
	getInvitationsFailure,
	getInvitationsSuccess,
	removeInvitation,
	updateInvitation,
} from './invitations.actions';

type InboxResponse = {
	invitations: Invitation[];
};

@Injectable()
export class InvitationsEffects {
	getInvitations$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getInvitations),
			switchMap(() =>
				this.http.get<InboxResponse>('v1/inbox/student', {}, undefined).pipe(
					map((inbox) => {
						const invitations = inbox.invitations.map((invitation) => Invitation.fromJSON(invitation)).filter(isTruthy);
						return getInvitationsSuccess({ invitations });
					}),
					catchError((error) => of(getInvitationsFailure({ errorMessage: error.message })))
				)
			)
		)
	);

	receiveUpdate$ = createEffect(() =>
		this.actions$.pipe(
			ofType(receiveUpdate),
			map((action) => {
				const { event } = action;
				switch (event.action) {
					case 'pass_invitation.create': {
						const invitation = Array.isArray(event.data) && Invitation.fromJSON(event.data[0]);
						return invitation && addInvitation({ invitation });
					}
					case 'pass_invitation.update': {
						const invitation = Invitation.fromJSON(event.data);
						return invitation && updateInvitation({ invitation });
					}
					case 'pass_invitation.cancel':
					case 'pass_invitation.deny': {
						const invitation = Invitation.fromJSON(event.data);
						return invitation && removeInvitation({ id: invitation.id });
					}
					case 'pass_invitation.accept': {
						const invitationId = HallPass.fromJSON(event.data)?.parent_invitation;
						return invitationId != null && removeInvitation({ id: parseInt(invitationId) });
					}
					default:
						return null;
				}
			}),
			pickTruthy()
		)
	);

	constructor(private actions$: Actions, private http: HttpService) {}
}
